import { CopilotActions } from 'actions/actionTypes';

import { MESSAGE_STATUS_OPTIONS } from 'constants/copilot';

const initialCopilotState = {
  sessions: {
    data: {}
  },
  fetching: false,
  loading: false,
  error: null,
  windowMode: 'embedded',
  chatContext: null
};

const copilot = (state = initialCopilotState, action) => {
  switch (action.type) {
    case CopilotActions.FETCH_COPILOT_CHAT_REQUEST: {
      return {
        ...state,
        fetching: true,
        loading: true,
        error: null
      };
    }
    case CopilotActions.FETCH_COPILOT_CHAT_SUCCESS: {
      return {
        ...state,
        sessions: {
          ...state.sessions,
          data: {
            ...state.sessions.data,
            ...action.response
          }
        },
        fetching: false,
        loading: false,
        error: null
      };
    }
    case CopilotActions.CREATE_COPILOT_CHAT_REQUEST:
    case CopilotActions.UPDATE_COPILOT_CHAT_NAME_REQUEST:
    case CopilotActions.DELETE_COPILOT_CHAT_REQUEST: {
      return {
        ...state,
        fetching: false,
        loading: true,
        error: null
      };
    }
    case CopilotActions.CREATE_COPILOT_CHAT_SUCCESS: {
      return {
        ...state,
        sessions: {
          ...state.sessions,
          data: {
            ...state.sessions.data,
            [action.response.uuid]: {
              ...action.response,
              contextType: action.contextType,
              contextUuid: action.contextUuid
            }
          }
        },
        fetching: false,
        loading: false,
        error: null
      };
    }
    case CopilotActions.UPDATE_COPILOT_CHAT_NAME_SUCCESS: {
      return {
        ...state,
        sessions: {
          ...state.sessions,
          data: {
            ...state.sessions.data,
            [action.response.uuid]: {
              ...state.sessions.data[action.response.uuid],
              name: action.response.name
            }
          }
        },
        fetching: false,
        loading: false,
        error: null
      };
    }
    case CopilotActions.DELETE_COPILOT_CHAT_SUCCESS: {
      const { [action.uuid]: removedSession, ...remainingSessions } =
        state.sessions.data;

      return {
        ...state,
        sessions: {
          ...state.sessions,
          data: remainingSessions
        },
        fetching: false,
        loading: false,
        error: null
      };
    }
    case CopilotActions.FETCH_COPILOT_CHAT_FAILURE:
    case CopilotActions.CREATE_COPILOT_CHAT_FAILURE:
    case CopilotActions.UPDATE_COPILOT_CHAT_NAME_FAILURE:
    case CopilotActions.DELETE_COPILOT_CHAT_FAILURE: {
      return {
        ...state,
        fetching: false,
        loading: false,
        error: action.error
      };
    }
    case CopilotActions.RECEIVE_COPILOT_MESSAGE: {
      const { chatUuid, uuid, sequence } = action.data || {};

      const existingSession = state.sessions.data[chatUuid] || {};
      const messages = existingSession.messages || [];

      const messageIndex = messages.findIndex(
        message => message && message.uuid === uuid
      );

      const isStreamingMessage =
        action.data.status === MESSAGE_STATUS_OPTIONS.IN_PROGRESS;

      let newMessages;

      if (uuid) {
        if (messageIndex === -1) {
          // For new messages with UUID, insert at the correct position based on sequence
          const insertIndex = messages.findIndex(
            msg => (msg.sequence || 0) > (sequence || 0)
          );
          newMessages =
            insertIndex === -1
              ? [...messages, action.data] // Append to end if no higher sequence found
              : [
                  ...messages.slice(0, insertIndex),
                  action.data,
                  ...messages.slice(insertIndex)
                ];
        } else {
          // Update existing message
          newMessages = [
            ...messages.slice(0, messageIndex),
            {
              ...messages[messageIndex],
              ...action.data,
              message:
                (messages[messageIndex].message || '') +
                (action.data.message || '')
            },
            ...messages.slice(messageIndex + 1)
          ];
        }
      } else {
        // For messages without UUID (like user messages), insert at the correct position
        const insertIndex = messages.findIndex(
          msg => (msg.sequence || 0) > (sequence || 0)
        );
        newMessages =
          insertIndex === -1
            ? [...messages, action.data] // Append to end if no higher sequence found
            : [
                ...messages.slice(0, insertIndex),
                action.data,
                ...messages.slice(insertIndex)
              ];
      }

      return {
        ...state,
        sessions: {
          ...state.sessions,
          data: {
            ...state.sessions.data,
            [chatUuid]: {
              ...existingSession,
              messages: newMessages
            }
          }
        },
        loading: isStreamingMessage
      };
    }
    case CopilotActions.RECEIVE_COPILOT_NAME_UPDATE: {
      return {
        ...state,
        sessions: {
          ...state.sessions,
          data: {
            ...state.sessions.data,
            [action.data.chatUuid]: {
              ...state.sessions.data[action.data.chatUuid],
              name: action.data.name
            }
          }
        }
      };
    }
    case CopilotActions.MESSAGE_TIMEOUT: {
      return {
        ...state,
        fetching: false,
        loading: false
      };
    }
    case CopilotActions.SET_COPILOT_WINDOW_MODE: {
      return {
        ...state,
        windowMode: action.windowMode
      };
    }
    case CopilotActions.SET_COPILOT_CHAT_CONTEXT: {
      return {
        ...state,
        chatContext: action.chatContext
      };
    }
    case CopilotActions.EMPTY_COPILOT_CHAT_CONTEXT: {
      return {
        ...state,
        chatContext: null
      };
    }
    default:
      return state;
  }
};

export default copilot;
